<template>
  <CommonNoticeCard
    :class="b()"
  >
    <div
      slot="content"
      :class="b('title')"
    >
      {{ btnTextEvent.desc }}
    </div>
    <template #actions>
      <el-button
        v-if="hasUpgradePermission"
        type="primary"
        :class="b('btn')"
        size="mini"
        @click.stop="btnTextEvent.event"
      >
        {{ btnTextEvent.text }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';
import * as permission from 'common-module/src/config/permission';
import { mapGetters } from 'vuex';

export default {
  name: 'ProjectCollaboratorNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('user', ['checkAccessPermission']),
    hasUpgradePermission() {
      if (this.$store.getters.isAWSUserMark) {
        return false;
      }
      return this.checkAccessPermission(permission.upgrade);
    },
    btnTextEvent() {
      return this.hasUpgradePermission ? {
        desc: this.data.adminDesc,
        text: this.$t('button.Upgrade'),
        event: () => {
          this.eventBus.$emit('global:openUpgradeDialog');
        }
      } : {
        desc:  this.data.normalDesc
      };
    }
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@include b(project-collaborator-notice-card) {
  @include e(btn) {
    color: var(--font-color-5) !important;
  }
  @include e(title) {
    color: var(--font-color-2);
  }
}
</style>
<style>
.project-collaborator-notice-card {
  z-index: 9999!important;
  &:before{
    background-color: var(--primary-color);
  }
  .el-notification__title {
    color: var(--font-color-1);
  }
}
</style>
